import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { EmployerService } from 'src/app/core/services/modules/employer.service';
import { environment } from 'src/environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { FilterMultipleService } from '../../../../core/services/utils/filter-multiple.service';
import { CommonOptions, DatesPeriods, FilterList } from 'src/app/core/interfaces/interfaces';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/services/modules/common.service';
import { FormControl } from '@angular/forms';
import { FechasService } from 'src/app/core/services/utils/fechas.service';

export interface DialogData {
  period: string;
}

@Component({
  selector: 'app-dialog-liquidaciones',
  templateUrl: './dialog-liquidaciones.component.html',
  styleUrls: ['./dialog-liquidaciones.component.scss']
})
export class DialogLiquidacionesComponent implements OnInit {
  filterListValue = '';
  production: boolean = environment.production;

  period: string;
  s3Bucket: string;
  filterValue = '';

  arreglo: any[] = [];
  employers: any = [];
  employersSlice: any = [];
  dataRange: DatesPeriods[] = [];
  socialSecurityDocumentState: CommonOptions[] = [];

  controlFormControl = new FormControl();

  columnsLiquidaciones: string[] = ['DocumentType', 'DocumentNumber', 'Name', 'state', 'user', 'actions'];
  tableDataSourceLiquidaciones: MatTableDataSource<any>;
  @ViewChild('paginatorLiquidaciones', {read: MatPaginator}) paginatorLiquidaciones: MatPaginator;
  @ViewChild(MatSort) sortLiquidaciones: MatSort;
  @ViewChild('paginatorEmployers', {read: MatPaginator}) paginatorEmployers: MatPaginator;

  filterList: FilterList[] = [
    { Id: 1, Value: '', Name: 'Todos', icon: 'business', count: null},
    { Id: 2, Value: 'ADMINISTRADAS', Name: 'ADMINISTRADAS', icon: 'business', count: null}
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogLiquidacionesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private employerService: EmployerService,
    private filters: FilterMultipleService,
    private commonService: CommonService,
    private fechasService: FechasService,
  ) { }

  ngOnInit(): void {
    this.s3Bucket = environment.api.url;
    this.dataRange = this.fechasService.getListDateYYYYMM(1, 4);
    this.commonService.getCommonOptions('SocialSecurityDocumentState').subscribe(common => {
      this.socialSecurityDocumentState = common;
    });
    this.period = this.data.period;
    this.controlFormControl.setValue(this.data.period);
    this.getSocialSecurity(this.period);
  }

  getSocialSecurity(period): void {
    this.employerService.getSocialsecuritydocument(period).subscribe((socialSecurityData: any) => {
      // liquidaciones
      this.tableDataSourceLiquidaciones = new MatTableDataSource(socialSecurityData);

      // filtro filterPredicate objetos dentro de un array
      this.tableDataSourceLiquidaciones.filterPredicate = (rowData: any, filter: string): boolean => {
        const dataStr = JSON.stringify(rowData).toUpperCase();
        return dataStr.indexOf(filter) !== -1;
      };
      this.tableDataSourceLiquidaciones.paginator = this.paginatorLiquidaciones;
      this.tableDataSourceLiquidaciones.sort = this.sortLiquidaciones;
    });
  }

  getUrlFile(url) {
    const urlFile = this.s3Bucket + url;
    return urlFile;
  }

  openFileUrlFile(url, State) {
    if (State === 'Liquidated' || State === 'Pagado') {
      const urlFile = this.s3Bucket + url;
      window.open(urlFile);
    }
  }

  liquidar(CompanyId) {
    this.employerService.postSocialsecuritydocument(this.period, CompanyId).subscribe((document: any) => {
        this.getSocialSecurity(this.period);
        window.open(this.getUrlFile(document.url));
    });
  }

  pagarPlanilla(EmployerId) {
      this.employerService.putSocialsecuritydocumentState(this.period, EmployerId,
        this.getStateLiquidacion('Pagado')).subscribe(putSecurity => {
        this.getSocialSecurity(this.period);
      });
  }

  selectedPeriod(e) {
    this.period = e;
    this.getSocialSecurity(e);
  }

  close() {
    this.dialogRef.close();
  }

  getStateLiquidacion(state): number {
    const security: CommonOptions =  this.socialSecurityDocumentState.find(x => x.Value === state);
    if (security !== undefined) {
      return security.Id;
    } else {
      return 0;
    }
  }

  getImg(logo) {
    const img = (logo === null || logo === '' ? 'upload/images/form-images/file_235c080f-43b7-42c6-bd43-0af779cdb223.svg' : logo);
    return img;
  }

  searchLiquidacion(value: string)  {
    this.tableDataSourceLiquidaciones.filter = value.trim().toUpperCase();
  }

  searchFilterPagination(changeFilter: string){
    const startIndex = this.paginatorEmployers.pageIndex * this.paginatorEmployers.pageSize;
    let endIndex = startIndex + this.paginatorEmployers.pageSize;
    if (this.filterListValue === '' && changeFilter === '' && this.filterValue === '' ) {
      this.arreglo = this.employers;
    }else {
      this.filterListValue = changeFilter;
      this.arreglo = this.getEmployerSearch(this.filterListValue, this.filterValue);
    }

    if (endIndex > this.arreglo.length) {
      endIndex = this.arreglo.length;
    }
    this.employersSlice = this.arreglo.slice(startIndex, endIndex);
  }

  getEmployerSearch(value: string, filter?: string): any[] {
    if (value === '' && (filter === '' || filter === undefined)) {
        return this.employers;
    } else if (filter === 'ADMINISTRADAS'){
        return this.employers.filter(x => {
            return  ((this.filters.exitFilter(x.Name , value) ||
                    this.filters.exitFilter(x.StateName, value) ||
                    this.filters.exitFilter(x.DocumentNumber, value) ||
                    this.filters.exitFilter(x.DocumentType, value)) &&
                    (x.IsManaged === true));
        });
    }else {
      return this.employers.filter(x => {
        return  (this.filters.exitFilter(x.Name , value) ||
                this.filters.exitFilter(x.StateName, value) ||
                this.filters.exitFilter(x.DocumentNumber, value) ||
                this.filters.exitFilter(x.DocumentType, value));
      });
    }
  }
}
